import useSchedulesQuery from "@/shared/queries/schedules/useSchedulesQuery";
import { formatDate } from "@/shared/utils/helpers";
import dayjs from "dayjs";
import { useEffect, useState } from "react";

interface DayState {
  day: string;
  value: string[];
}

const useScheduleHook = (initialDate?: string) => {
  const get = (value?: string): DayState => {
    const time = "04:00";
    const selectedDate = value ?? new Date();
    const day = formatDate(selectedDate, "inputDate");
    const tomorrow = formatDate(
      dayjs(selectedDate).add(1, "day"),
      "inputDate",
    );
    const start = `${day} ${time}`;
    const end = `${tomorrow} ${time}`;
    return {
      day,
      value: [start, end],
    };
  };

  const set = (day: string) => setDay(get(day));

  const [day, setDay] = useState<DayState>(get(initialDate));
  const query = useSchedulesQuery({
    start_date_and_time: day.value[0],
    end_date_and_time: day.value[1],
  });

  useEffect(() => {
    setDay(get(initialDate));
  }, [initialDate]);

  return { get, day, set, ...query };
};

export default useScheduleHook;
